import React, { useState, useContext } from 'react';
import classNames from 'classnames/bind';
import ChartBase from './chart-base';
import { useChartBase } from './chart-base';
import { formatClassName, humanizeNumber } from "./chart-base";
import SessionContext from 'SessionContext';
import TweenedNumber from 'core/ui/tweened-number';
import LabelWithTooltip from './label-with-tooltip';

const CountWidget = (props) => {
  const base = useChartBase(props);
  const context = useContext(SessionContext);
  const [specialCaseLabels, setSpecialCaseLabels] = useState({});

  // Use custom renderChart if provided, otherwise use default
  const chartRenderer = props.renderChart
    ? () => props.renderChart({ ...props, base, specialCaseLabels, setSpecialCaseLabels })
    : () => renderChart();

  function getClassName() {
    const filters = props.filters || [],
      isFiltered = filters.length,
      isNegated = isFiltered && filters[0].is_negated;
    return classNames('count-widget', { 'is-negated': isNegated });
  }

  function renderChart() {
    if (Object.keys(props.values).length === 0) { return }
    const config = props.config;
    let filters = props.filters || [];
    const viewOnly = props.viewOnly;
    const shouldTween = props.tween;
    let value_series = config.ds + '.' + config.id;
    let val_src = props.values;
    let prefix = context.crossfilterStore.geoPrefix;
    let is_state = `${prefix}state`;

    if(props.viewOnly && (props.config.id === is_state)){
      val_src = context.crossfilterStore.counts_filtered;
      value_series = `${prefix}geo.${prefix}state`;
      filters = context.crossfilterStore.filters[is_state] || [];
    }

    const values = val_src[value_series] || {};
    let chartIsNegated = 0;
    if (filters.length > 0) {
      filters.forEach(filter => {
        if (filter.is_negated) {
          chartIsNegated = 1;
        }
      });
    }

    if (chartIsNegated) {
      filters.forEach(filter => filter.is_negated = 1);
      props.config.excluded = "excluded: ";
    }
    let labels = config.value_labels;

    if (!labels || Object.keys(labels).length === 0) {
      labels = {};
      Object.entries(values).forEach(([val, _]) => labels[val] = val);
    }

    let isSpecialCaseLabelsSet = specialCaseLabels ? Object.keys(specialCaseLabels) : [];

    if (!viewOnly &&
      !isSpecialCaseLabelsSet.length &&
      !(props.config.id === is_state) &&
      labels &&
      Object.keys(labels).length > 0) {
      setSpecialCaseLabels(labels);
    }

    const isState = props.config.id === `${prefix}state`;

    let sortedList = base.sortListOutput(labels, values, filters);
    let updatedLabelList = base.updatedLabelList;

    if(base.updatedLabelList && base.searchText.length) {
      sortedList = base.sortListOutput(updatedLabelList, values, filters);
    } 

    if(base.updatedLabelList && !Object.keys(base.updatedLabelList).length) {
      return <div className="flex-row">No Values Found</div>
    }

    if (!sortedList) { return; }

    return sortedList.map(item => {
      const filterEntry = item.filtered;
      const isFiltered = filterEntry;
      const isNegated = isFiltered && item.is_negated;
      const value = item.value || 0;
      const id = item.id;
      const label = item.label;

      return (
        <div className={`flex-row ${!filterEntry ? "unfiltered" : ""}`} key={id}>
          {!viewOnly && isState && (
            <span onClick={() => base.handleFlyToState(label)}>
              <i className="fa-solid fa-crosshairs" />
              &nbsp;
            </span>
          )}
          <div
            className={classNames(
              "value",
              `${formatClassName(label)}-count`,
              {
                selected: isFiltered,
                not: (isNegated || chartIsNegated) && !viewOnly,
              }
            )}
            onClick={() => base.onFilterClick(!isFiltered, config, value_series, id, chartIsNegated)}
          >
            <LabelWithTooltip label={label} parentProps={props} cssClass="inner" />
            <i className="spacer"></i>
            {shouldTween && <TweenedNumber className="count" value={value} />}
            {!shouldTween && (
              <span className="count">{humanizeNumber(value)}</span>
            )}
          </div>
        </div>
      );
    });
  }

  return (
    <ChartBase 
      {...props} 
      base={base} 
      chartClassName={getClassName()}>
      <div className={getClassName()}>
        {chartRenderer()}
      </div>
    </ChartBase>
  );
};

export default CountWidget;
